import React from 'react';
import { Flex } from 'core/components';
import KaizenSidebar from './KaizenSidebar';

/**
 * Sidebar + content layout for AI Advisor pages outside of the chat view (history, settings),
 * so navigating between them stays within the AI Advisor UI.
 */
const KaizenSidebarLayout = ({ children, onSelectJourney }) => (
  <Flex height="100%" width="100%">
    <Flex flexDirection="column" flex={1} minWidth={0} height="calc(100vh - 100px)">
      {children}
    </Flex>
    <KaizenSidebar onSelectJourney={onSelectJourney} />
  </Flex>
);

export default KaizenSidebarLayout;
